import React, { useEffect, useState } from "react";
import "./Documents_Management.css";
import { Button, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPen,
  faTrashAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Upload_documents_modal from "../../../../common_components/common_modal/upload_documents_modal/Upload_documents_modal";
import {
  Create,
  GetAll,
  Delete,
} from "../../../../../features/admin/student/add_student_documents/Slice";
import { useDispatch, useSelector } from "react-redux";
import CustomPaginate from "../../../../../common/custompaginate/CustomPaginate";
import { IDS } from "../../../../../utils/IDS";
import successAnimation from "../../../../animation/success_lottie/Success_lottie.json";
import Edit_documents_modal from "../../../../common_components/common_modal/edit_documents_modal/Edit_documents_modal";
import Success_modal from "../../../../common_components/common_modal/success_modal/Success_modal";
function Documents_Management() {
  const dispatch = useDispatch();

  const [showEdit, setShowEdit] = useState(false);
  const [id, setId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  console.log(deleteId, "deleteId");

  const [modalUploadShow, setModalUploadShow] = React.useState(false);

  const AllUserDocument = useSelector(
    (state) => state?.studentapplication?.add_student_documents
  );

  console.log(AllUserDocument, "AllUserDocument");

  const fetch = async (page = AllUserDocument?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: "",
        page: page,
        per_page: AllUserDocument?.per_page,
      })
    );
  };

  useEffect(() => {
    fetch();
  }, []);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const handleDelete = async () => {
    try {
      const res = await dispatch(Delete(id));

      console.log(res);

      if (res.meta?.requestStatus == "fulfilled") {
        setModalsuccessShow(true);
        fetch();
      }
      setTimeout(() => {
        setModalsuccessShow(false);
        setShowDeleteModal(false);
      }, 3000);

      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return (
    <>
      <section className="Documents_Management ">
        <div className="heading_text_holder">
          <h4>
            You have <span>2 documents remaining</span> to complete your upload
            process. Please submit them to continue your application.
          </h4>
        </div>

        <div className="card_box">
          <div className="heading_btn_holder">
            <h5 className="mb-3 card_heading_holder">Documents</h5>
            <div className="btn_holder">
              <Blue_border_button
                button_text={
                  <>
                    <FontAwesomeIcon icon={faUpload} /> Upload Documents{" "}
                  </>
                }
                onClick={() => setModalUploadShow(true)}
              />
            </div>
          </div>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  {" "}
                  <th>Sr. No.</th>
                  <th>Document Name</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {AllUserDocument?.data?.length > 0 ? (
                  AllUserDocument?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(AllUserDocument?.current_page - 1) *
                          AllUserDocument?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val.StudentDocument?.name}</td>
                      <td>
                        {" "}
                        {val?.image && (
                          <img
                            src={`${IDS.IMG_URL}${val?.image}`}
                            alt="Image"
                            width="120"
                            height="100"
                          />
                        )}
                      </td>
                      <td>{val.Ticket_Status?.name}</td>

                      <td>
                        <div className="action_btn_holder">
                          {/* <Button
                            className="eye_btn action_btn_icon"
                            onClick={() => {
                              setShowEdit(val?.id);
                              setId(val?.id);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </Button> */}

                          <Button
                            className="trash_btn action_btn_icon"
                            onClick={() => {
                              setDeleteId(val.id);
                              setId(val?.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={AllUserDocument?.current_page}
              totalPages={AllUserDocument?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      <Upload_documents_modal
        show={modalUploadShow}
        onHide={() => setModalUploadShow(false)}
      />

      <Edit_documents_modal
        show={showEdit}
        id={id}
        onHide={() => setShowEdit(false)}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this state?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={handleDelete} // ✅ THIS IS WHERE YOU CALL IT
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Documents_Management;
